import React from "react";
import { Outlet } from "react-router-dom";
import Page404 from "../../../views/user/Auth/Page404";

// Warning Dashboard's threshold-configuration screens are Finance-only - same pattern as HrRoute.jsx.
// The backend also enforces this on every threshold endpoint (requireFinance.middleware.js) - this route
// guard is what stops a non-Finance user from even loading the page by typing/bookmarking the URL.
const FinanceRoute = ({ children }) => {
    const profile = JSON.parse(localStorage.getItem("cred")).profile;
    if (profile.departmentName === "Finance") {
        return children ? children : <Outlet />;
    } else {
        return (
            <Page404
                message={
                    "Sorry!! You don'nt have the permission for such an action"
                }
            />
        );
    }
};

export default FinanceRoute;
